export * from "./Switch.settings";
